import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ContextData } from './context/Data/ContextData';
function Main() {
  const [data, setData] = useState();
  // const [state, dispatch] = useReducer(MessagesAllChatReducer, initialState);
  // const [lastMessage, dispatchLastMessage] = useReducer(MessagesAllChatReducer, initialState);
  return (
    <React.StrictMode>
      <ContextData.Provider value={{ data, setData }}>
        {/* <ContextApp.Provider value={{ state, dispatch }}>
          <ContextLastMessage.Provider value={{ lastMessage, dispatchLastMessage }}> */}
        <App />
        {/* </ContextLastMessage.Provider>
        </ContextApp.Provider> */}
      </ContextData.Provider>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Main />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
